import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { Theme } from 'scripts/react-components/themes/Theme'

const wrapperStyles = ({ theme }: Theme) => css`
  label: wrapper;

  padding: ${theme.spacings.mega};
  margin-bottom: ${theme.spacings.mega};

  width: 100%;

  background: ${theme.colors.n100};

  border-radius: ${theme.borderRadius.giga};
`

export const Wrapper = styled('div')(wrapperStyles)
